import { useRef, useCallback, useEffect } from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { canUseVisualViewport } from '@eika/hooks';

/**
 * Beware! If you change this file you need to check that it works in:
 * - Receiver modal: edit and create, foreign and domestic
 * - Payment/Transfer modal; to and from accounts, receipt, date, kid / text fields
 * - Cross border payment: 'beløp' page, similar to previous point
 * - Changing favorite account and account order
 * If all of those things work -> you are good to go
 */

function calculateOffsetBottom() {
    const height = window.visualViewport?.height ?? 0;
    return window.innerHeight - height - (window.visualViewport?.offsetTop ?? 0);
}

const calculateOffsetTop = () =>
    Math.min(window.visualViewport?.height || 0, window.outerHeight || 0) -
    45 +
    (window.visualViewport?.offsetTop ?? 0);

const useStickyFooter = (footerRef: React.RefObject<HTMLDivElement>): void => {
    const pendingUpdateRef = useRef(false);

    const viewportHandler = useCallback(() => {
        if (pendingUpdateRef.current) {
            return;
        }
        pendingUpdateRef.current = true;

        requestAnimationFrame(() => {
            pendingUpdateRef.current = false;
            if (footerRef.current) {
                if (runningInRNWebView) {
                    footerRef.current.style.transform = `translate(0, ${-calculateOffsetBottom()}px)`;
                } else {
                    footerRef.current.style.top = `${calculateOffsetTop()}px`;
                    footerRef.current.style.bottom = 'unset';
                }
            }
        });
    }, [footerRef]);

    useEffect(() => {
        if (canUseVisualViewport && window.visualViewport) {
            window.visualViewport.addEventListener('scroll', viewportHandler);
            window.visualViewport.addEventListener('resize', viewportHandler);
            viewportHandler();
        }
        return () => {
            if (canUseVisualViewport && window.visualViewport) {
                window.visualViewport.removeEventListener('scroll', viewportHandler);
                window.visualViewport.removeEventListener('resize', viewportHandler);
            }
        };
    }, [viewportHandler]);
};

export default useStickyFooter;
